<!-- begin::Header -->
<header
    class="m-grid__item m-header px-0"
    data-minimize="minimize"
    data-minimize-offset="200"
    data-minimize-mobile-offset="200"
    appunwraptag="">
    <div class="m-header__top px-5">
        <div class="m-container m-container--responsive m-container--full-height m-page__container px-5">
            <div class="m-stack m-stack--ver m-stack--desktop">
                <!-- begin::Brand -->
                <div class="m-stack__item m-brand">
                    <div class="m-stack m-stack--ver m-stack--general m-stack--inline">
                        <div class="m-stack__item m-stack__item--middle m-brand__tools mobile-view">
                            <button
                                id="m_aside_header_menu_mobile_toggle"
                                class="m-brand__icon m-brand__toggler"
                                type="button"
                                data-bs-toggle="offcanvas"
                                data-bs-target="#offcanvasMenu"
                                aria-controls="offcanvasMenu">
                                <span></span>
                            </button>
                            <a
                                id="m_aside_header_topbar_mobile_toggle"
                                href="javascript:;"
                                class="m-brand__icon m--visible-tablet-and-mobile-inline-block no-print">
                                <i class="flaticon-more"></i>
                            </a>
                        </div>
                        <div
                            class="m-stack__item m-stack__item--middle m-brand__logo mobile-view-logo"
                            [hidden]="!hideLHGLogo">
                            <a routerlink="/dashboard/index" class="m-brand__logo-wrapper" href="#/dashboard/index">
                                <!-- Regular logo -->
                                <!-- <img
                alt="Pulse by RHG logo"
                src="./assets/app/media/img/logos/pulse_logo_h85-min.png"
                /> -->
                                <!-- New Regular logo -->
                                <img
                                    class="pulse-logo"
                                    alt="Pulse by The Club logo"
                                    src="./assets/app/media/img/logos/PULSE_BY_CLUB_LOGO_POSITIVE_RGB.png" />
                                <!-- Halloween logo -->
                                <!-- <img
                  class="pulse-logo"
                  alt="Pulse by RHG logo"
                  src="./assets/app/media/img/logos/pulse_logo_halloween_2025.png"
                  /> -->
                                <!-- <img
                  class="pulse-logo-hover"
                  alt="Pulse by RHG logo"
                  src="./assets/app/media/img/logos/pulse_logo_halloween_2025.gif"
                  /> -->
                                <!-- Christmas logo -->
                                <!-- <img
                  class="pulse-logo"
                  alt="Pulse by RHG logo"
                  src="./assets/app/media/img/logos/pulse-santa-sled-rudolf.gif"
                  /> -->
                                <!-- <img
                  class="pulse-logo-hover"
                  alt="Pulse by RHG logo"
                  src="./assets/app/media/img/logos/pulse-santa-sled.gif"
                  />  -->
                                <!-- Summer logo -->
                                <!-- <img
                  alt="Pulse by RHG logo"
                  src="./assets/app/media/img/logos/summer-logo.png"
                  /> -->
                                <!-- <img
                  class="pulse-logo-hover"
                  alt="Pulse by RHG logo"
                  src="./assets/app/media/img/logos/summer-logo.gif"
                  /> -->
                            </a>
                        </div>
                        <div
                            class="m-stack__item m-stack__item--middle m-brand__logo mobile-view-logo"
                            [hidden]="hideLHGLogo">
                            <a routerLink="/dashboard/index" class="m-brand__logo-wrapper" href="#/dashboard/index">
                                <img
                                    class="pulse-logo"
                                    alt="Louvre Hotels logo"
                                    src="./assets/app/media/img/logos/PULSE_BY_LHG_LOGO_RGB.png" />
                            </a>
                        </div>
                        <!-- When REGULAR LOGO - Remove inline margin-top style  -->
                        <div class="m-nav__item-container" id="load_status" (click)="openImportControl()">
                            <div id="status_kpi">
                                <!-- When REGULAR LOGO - Uncomment padding-top in #load_status -->
                                <span class="load_status_text">Rooms</span>
                                <mat-progress-spinner
                                    class="example-margin"
                                    [mode]="mode"
                                    [value]="value_rooms"
                                    diameter="22"
                                    [matTooltip]="rooms_tooltip"
                                    strokeWidth="5"
                                    [color]="getSpinnerColor(value_rooms)">
                                </mat-progress-spinner>
                                <span class="load_status_text" style="margin-right: 10px">{{ value_rooms }}%</span>
                            </div>

                            @if (company == 'rhg') {
                                <div id="status_kpi">
                                    <span class="load_status_text">M&E</span>
                                    <mat-progress-spinner
                                        class="example-margin"
                                        [mode]="mode"
                                        [value]="value_me"
                                        diameter="22"
                                        [matTooltip]="me_tooltip"
                                        strokeWidth="5"
                                        [color]="getSpinnerColor(value_me)">
                                    </mat-progress-spinner>
                                    <span class="load_status_text">{{ value_me }}%</span>
                                </div>
                            }
                        </div>
                    </div>
                </div>

                <!-- begin::Topbar -->
                <div class="m-stack__item m-stack__item--fluid m-header-head" id="m_header_nav">
                    <div id="m_header_topbar" class="m-topbar m-stack m-stack--ver m-stack--general">
                        <div class="m-stack__item m-topbar__nav-wrapper">
                            <ul class="m-topbar__nav m-nav m-nav--inline">
                                <li class="m-nav__item">
                                    <div class="m-nav__item-container" id="theme-switcher">
                                        <div ngbDropdown #headerDrop="ngbDropdown" class="no-close small no-padding">
                                            <div ngbDropdownToggle class="button no-anchor" style="cursor: pointer">
                                                @if (themeService.isDarkTheme()) {
                                                    <span class="m-topbar__welcome"> </span>
                                                }
                                                <a
                                                    class="badge-link"
                                                    (click)="openLeaderboard($event, headerDrop)"
                                                    ngbTooltip="Open Leaderboard"
                                                    placement="bottom"
                                                    aria-label="Open Leaderboard">
                                                    <badge-rating></badge-rating>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </li>
                                <li class="m-nav__item">
                                    <div class="m-nav__item-container">
                                        <div
                                            ngbDropdown
                                            #headerDrop="ngbDropdown"
                                            class="no-close small no-padding"
                                            (openChange)="onUserMenuOpen($event)">
                                            <div ngbDropdownToggle class="button no-anchor" style="cursor: pointer">
                                                <span class="m-topbar__welcome"> Hello,&nbsp; </span>
                                                <span class="m-topbar__username">
                                                    {{ user.first_name + ' ' }}&nbsp;
                                                </span>
                                                <span class="m-topbar__userpic">
                                                    <img
                                                        src="/users-images/{{
                                                            user.profile_image ? user.profile_image : 'user-128.png'
                                                        }}"
                                                        class="m--img-rounded m--marginless m--img-centered"
                                                        id="header-image"
                                                        alt="user logo"
                                                        style="width: auto; height: auto; border-radius: 50%" />
                                                </span>
                                            </div>
                                            <div
                                                ngbDropdownMenu
                                                class="dropdown-content"
                                                style="padding: 0px; border: 0">
                                                <span class="p-dropdown-arrow"></span>
                                                <div class="p-dropdown-header">
                                                    <div class="m-card-user m-card-user--skin-dark">
                                                        <div class="m-card-user__pic">
                                                            <app-avatar></app-avatar>
                                                        </div>
                                                        <div class="m-card-user__details">
                                                            <span
                                                                class="m-card-user__name m--font-weight-500 text-white">
                                                                {{ user.first_name }}
                                                                {{ user.last_name }}
                                                            </span>
                                                            <span
                                                                class="m-card-user__email m--font-weight-300 m-link text-white">
                                                                {{ user.title }}
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="p-dropdown-body">
                                                    <div class="p-dropdown-content">
                                                        <ul class="m-nav m-nav--skin-light">
                                                            <li class="m-nav__section m--hide">
                                                                <span class="m-nav__section-text" zzz> Section </span>
                                                            </li>
                                                            <!-- Points / Stats -->
                                                            <li
                                                                class="m-nav__item points-stats"
                                                                aria-label="Points summary"
                                                                role="group">
                                                                <div class="points-stats">
                                                                    <div class="points-title">POINTS</div>

                                                                    <div class="stats stats--three">
                                                                        <div class="stat">
                                                                            <div class="icon-pill total-icon">
                                                                                <mat-icon>military_tech</mat-icon>
                                                                            </div>
                                                                            <div class="value total">
                                                                                {{
                                                                                    this.forumService.userPoints
                                                                                        | number: '1.0-0'
                                                                                }}
                                                                            </div>
                                                                            <div class="label">Total</div>
                                                                        </div>

                                                                        <div class="stat">
                                                                            <div class="icon-pill week-icon">
                                                                                <mat-icon>trending_up</mat-icon>
                                                                            </div>
                                                                            <div class="value week">
                                                                                {{
                                                                                    this.forumService.weekPoints
                                                                                        | number: '1.0-0'
                                                                                }}
                                                                            </div>
                                                                            <div class="label">This week</div>
                                                                        </div>

                                                                        <div class="stat">
                                                                            <div class="icon-pill next-icon">
                                                                                <mat-icon>arrow_upward</mat-icon>
                                                                            </div>
                                                                            <div class="value next">
                                                                                {{ forumService.getPointsToNextLevel }}
                                                                            </div>
                                                                            <div class="label">Next level</div>
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                                <div class="points-title">
                                                                    {{ pointsMessage }}
                                                                </div>
                                                            </li>
                                                            @if (user.access_level > 0 && user.access_level < 3) {
                                                                <li class="m-nav__item">
                                                                    <a
                                                                        ngbDropdownItem
                                                                        routerLink="/admin"
                                                                        class="m-nav__link">
                                                                        <i
                                                                            class="m-nav__link-icon flaticon-user-settings"></i>
                                                                        <span class="m-nav__link-text"> Admin </span>
                                                                    </a>
                                                                </li>
                                                            }
                                                            <li class="m-nav__item">
                                                                <a
                                                                    ngbDropdownItem
                                                                    routerLink="/profile"
                                                                    class="m-nav__link">
                                                                    <i class="m-nav__link-icon flaticon-user"></i>
                                                                    <span class="m-nav__link-text">Profile</span>
                                                                </a>
                                                            </li>

                                                            <!-- IF on /forum*, show the widget directly -->

                                                            <!-- ELSE, show a routerLink to /dashboard/achievments with the badge value -->
                                                            <li class="m-nav__item">
                                                                <a
                                                                    ngbDropdownItem
                                                                    [routerLink]="['/dashboard/achievments']"
                                                                    class="m-nav__link">
                                                                    <i class="m-nav__link-icon">
                                                                        <img
                                                                            src="assets/app/media/achievements/badge1-svgrepo-com.svg"
                                                                            width="20"
                                                                            alt="Achievements Icon" />
                                                                    </i>
                                                                    <span class="m-nav__link-text"> Achievements </span>
                                                                    @if (info?.achievementsBadge) {
                                                                        <span class="m-nav__link-badge"> </span>
                                                                    }
                                                                </a>
                                                            </li>

                                                            @if (user.access_level > 0 && user.access_level < 3) {
                                                                <li class="m-nav__item">
                                                                    <a
                                                                        ngbDropdownItem
                                                                        [routerLink]="['/alerts']"
                                                                        class="m-nav__link">
                                                                        <i
                                                                            class="m-nav__link-icon flaticon-exclamation-2"></i>
                                                                        <span class="m-nav__link-text"> Alerts </span>
                                                                        @if (alertsService.totalAlertsNotClosed > 0) {
                                                                            <span class="m-nav__link-badge">
                                                                                <span class="m-badge m-badge--danger">
                                                                                    {{
                                                                                        alertsService.totalAlertsNotClosed
                                                                                    }}
                                                                                </span>
                                                                            </span>
                                                                        }
                                                                    </a>
                                                                </li>
                                                            }

                                                            <li class="m-nav__item">
                                                                <a
                                                                    class="m-nav__link"
                                                                    (click)="
                                                                        switchTheme(
                                                                            themeService.mode === 'light'
                                                                                ? 'dark'
                                                                                : 'light'
                                                                        );
                                                                        headerDrop.close()
                                                                    ">
                                                                    <i class="m-nav__link-icon">
                                                                        @if (themeService.mode === 'light') {
                                                                            <svg
                                                                                xmlns="http://www.w3.org/2000/svg"
                                                                                width="20"
                                                                                height="20"
                                                                                viewBox="0 0 24 24"
                                                                                fill="currentColor">
                                                                                <!-- Icono de luna -->
                                                                                <path
                                                                                    d="M21.64 13a9 9 0 01-11.64 8.49 9 9 0 001.44-17.73A9 9 0 0121.64 13z" />
                                                                            </svg>
                                                                        } @else {
                                                                            <svg
                                                                                xmlns="http://www.w3.org/2000/svg"
                                                                                width="20"
                                                                                height="20"
                                                                                viewBox="0 0 24 24"
                                                                                fill="currentColor">
                                                                                <!-- Icono de sol -->
                                                                                <path
                                                                                    d="M6.76 4.84l-1.8-1.79-1.42 1.41 1.79 1.8 1.43-1.42zm10.48 14.32l1.79 1.8 1.42-1.41-1.8-1.79-1.41 1.4zM12 4a1 1 0 011-1h.01a1 1 0 01.99 1v2a1 1 0 01-2 0V4zm0 14a1 1 0 011 1v2a1 1 0 01-2 0v-2a1 1 0 011-1zm8-6a1 1 0 01-1 1h-2a1 1 0 010-2h2a1 1 0 011 1zm-14 0a1 1 0 01-1 1H3a1 1 0 010-2h2a1 1 0 011 1zm11.66-5.66l1.8-1.79-1.41-1.42-1.79 1.8 1.4 1.41zM4.22 19.78l1.79-1.8-1.41-1.41-1.8 1.79 1.42 1.42z" />
                                                                                <circle cx="12" cy="12" r="5" />
                                                                            </svg>
                                                                        }
                                                                    </i>
                                                                    <span class="m-nav__link-text">
                                                                        {{
                                                                            themeService.mode === 'light'
                                                                                ? 'Dark Mode'
                                                                                : 'Light Mode'
                                                                        }}
                                                                    </span>
                                                                </a>
                                                            </li>

                                                            <!---------------------------------------->
                                                            <li class="m-nav__item">
                                                                <a
                                                                    class="m-nav__link"
                                                                    routerLink="/logout"
                                                                    (click)="headerDrop.close()">
                                                                    <i class="m-nav__link-icon flaticon-logout"></i>
                                                                    <span class="m-nav__link-text">Logout</span>
                                                                </a>
                                                            </li>
                                                        </ul>
                                                        <!---------------------------------------->
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </li>
                                <li class="m-nav__item">
                                    <span class="m-nav__link m-dropdown__toggle" id="sideBarButtonToggle">
                                        <span class="m-nav__link-icon m-nav__link-icon--aside-toggle">
                                            <button
                                                type="button"
                                                mat-icon-button
                                                ngbTooltip="Open Hotel Filters"
                                                placement="bottom"
                                                class="round-button"
                                                (click)="openQuickSideBar()">
                                                <i class="flaticon-menu-button"></i>
                                            </button>
                                        </span>

                                        <span (click)="openQuickSideBar()" class="m-nav__link-entity">
                                            @if (selectedAllowedHtl > 0) {
                                                <span title="Number of hotels in your selection">
                                                    ({{ selectedAllowedHtl }})
                                                </span>
                                            }
                                            {{ entityService.selectedEntityLabel }}
                                        </span>
                                    </span>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <!-- end::Topbar -->
            </div>
        </div>
    </div>
</header>
<div
    class="offcanvas offcanvas-start"
    tabindex="-1"
    id="offcanvasMenu"
    data-bs-scroll="true"
    data-bs-backdrop="true"
    aria-labelledby="sidebar-menu-wrapper">
    <div class="offcanvas-header">
        <h5 class="offcanvas-title" id="sidebar-menu-wrapper"></h5>
        <button
            type="button"
            class="{{
                globalService.localStorageItem('theme') == 'light'
                    ? 'btn-close text-reset'
                    : 'btn-close btn-close-white text-reset'
            }}"
            data-bs-dismiss="offcanvas"
            aria-label="Close"></button>
    </div>
    <div class="offcanvas-body text-center" id="sidebar-menu">
        <div class="m-stack__item m-stack__item--middle m-brand__logo" [hidden]="!hideLHGLogo">
            <a
                routerlink="/dashboard/index"
                class="m-brand__logo-wrapper"
                href="#/dashboard/index"
                onclick="$('.offcanvas').offcanvas('hide')">
                <!-- Regular Logo -->
                <!-- <img
                    alt="Pulse by RHG logo"
                    src="./assets/app/media/img/logos/pulse_logo_h85-min.png"
                    /> -->

                <!-- New Regular logo -->
                <img
                    class="pulse-logo"
                    alt="Pulse by RHG logo"
                    style="height: 110px"
                    src="./assets/app/media/img/logos/PULSE_BY_CLUB_LOGO_POSITIVE_RGB.png" />
                <!-- Halloween Logo -->
                <!-- <img class="pulse-logo" alt="Pulse by RHG logo" style="height: 110px"
                      src="./assets/app/media/img/logos/pulse_logo_halloween_2025.png" />
                      <img class="pulse-logo-hover" alt="Pulse by RHG logo" style="height: 110px"
                        src="./assets/app/media/img/logos/pulse_logo_halloween_2025.gif" /> -->
                <!-- Christmas Logo -->
                <!-- <img
                        class="pulse-logo"
                        alt="Pulse by RHG logo"
                        style="height: 110px"
                        src="./assets/app/media/img/logos/pulse-santa-sled-rudolf.gif"
                        /> -->
                <!-- <img
                        class="pulse-logo-hover"
                        alt="Pulse by RHG logo"
                        style="height: 110px"
                        src="./assets/app/media/img/logos/pulse-santa-sled.gif"
                        /> -->
                <!-- Summer logo -->
                <!-- <img
                        class="pulse-logo"
                        alt="Pulse by RHG logo"
                        style="max-height: 200px"
                        src="./assets/app/media/img/logos/summer-logo-side.png"
                        />
                        Summer logo on hover -->
                <!-- <img
                        class="pulse-logo-hover"
                        alt="Pulse by RHG logo"
                        style="max-height: 200px"
                        src="./assets/app/media/img/logos/summer-logo.gif"
                        /> -->
            </a>
        </div>
        <div class="offcanvas-body text-center" id="sidebar-menu">
            <div class="m-stack__item m-stack__item--middle m-brand__logo" [hidden]="hideLHGLogo">
                <a
                    routerLink="/dashboard/index"
                    class="m-brand__logo-wrapper"
                    href="#/dashboard/index"
                    onclick="$('.offcanvas').offcanvas('hide')">
                    <img
                        alt="Louvre Hotels logo"
                        src="./assets/app/media/img/logos/PULSE_BY_LHG_LOGO_RGB.png"
                        style="height: 110px" />
                </a>
            </div>
        </div>
        <div class="accordion mt-4" id="mainMenu">
            @if (!hideLHGLogo) {
                <div>
                    <a
                        routerLink="/dashboard/index"
                        class="home-btn"
                        data-bs-dismiss="offcanvas"
                        onclick="$('.collapse').collapse('hide')">
                        Home
                    </a>
                </div>
            }
            @if (pinnedDashboards.length > 0) {
                <div class="accordion-item">
                    <h2 class="accordion-header">
                        <button
                            class="accordion-button light-blue-highlight"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#my-dashboards">
                            My Dashboards
                        </button>
                    </h2>
                    <div id="my-dashboards" class="accordion-collapse collapse show" data-bs-parent="#mainMenu">
                        <div class="accordion-body">
                            <ul class="m-menu__subnav">
                                @for (dashboard of getPinnedDashboards(); track dashboard) {
                                    <li class="d-flex align-items-center gap-2">
                                        <i
                                            class="fa fa-thumb-tack"
                                            [ngStyle]="{
                                                color: '#bf9000',
                                                transform: 'rotate(-45deg)',
                                                cursor: 'pointer',
                                            }"
                                            (click)="togglePin(dashboard.id)"
                                            title="Unpin"></i>
                                        <a
                                            [routerLink]="['/dashboard', dashboard.id]"
                                            (click)="closeOffCanvas()"
                                            class="dashboard-link">
                                            <i class="m-menu__link-icon menu_icon flaticon-graphic-2"></i>
                                            {{ dashboard.name }}
                                        </a>
                                    </li>
                                }
                            </ul>
                        </div>
                    </div>
                </div>
            }

            @for (item of menu; track item) {
                <div class="accordion-item">
                    @if (item.name === 'user_guide') {
                        <hr [ngStyle]="{ color: themeService.isDarkTheme() ? 'white' : 'black' }" />
                    }
                    <h2 class="accordion-header" id="flush-headingOne">
                        <button
                            [ngClass]="{
                                'light-blue-highlight':
                                    item.label == 'News' || item.label === 'User Guide' || item.label === 'Community',
                            }"
                            class="accordion-button collapsed"
                            type="button"
                            data-bs-toggle="collapse"
                            [attr.data-bs-target]="'#' + item.name"
                            aria-expanded="false"
                            aria-controls="{{ item.label }}">
                            {{ item.label }}
                            @if (item.show_badge && numberOfNews) {
                                <span
                                    matBadge="{{ this.numberOfNews }}"
                                    matBadgeColor="warn"
                                    matBadgeSize="small"
                                    style="top: -7px; right: -7px"></span>
                            }
                        </button>
                    </h2>
                    <div
                        id="{{ item.name }}"
                        class="accordion-collapse collapse"
                        aria-labelledby="{{ item.label }}"
                        data-bs-parent="#mainMenu">
                        <div class="accordion-body">
                            <!-- Dashboards -->
                            @if (item.label !== 'News') {
                                <div class="accordion" id="{{ item.name }}-s">
                                    <div class="accordion-item">
                                        <h2 class="accordion-header" id="flush-headingOne">
                                            <button
                                                class="accordion-button collapsed"
                                                type="button"
                                                data-bs-toggle="collapse"
                                                [attr.data-bs-target]="'#' + item.name + '-as'"
                                                aria-expanded="false"
                                                aria-controls="{{ item.name }}">
                                                Dashboards
                                            </button>
                                        </h2>
                                        <div
                                            [id]="item.name + '-as'"
                                            class="accordion-collapse collapse show"
                                            aria-labelledby="{{ item.name }}"
                                            [attr.data-bs-parent]="'#' + item.name + '-s'">
                                            <div class="accordion-body">
                                                <ul class="m-menu__subnav">
                                                    @for (child of item.children; track child) {
                                                        <li>
                                                            @if (child.type == 'Dashboards') {
                                                                <div class="d-flex align-items-center gap-2">
                                                                    <i
                                                                        class="fa fa-thumb-tack"
                                                                        [ngStyle]="{
                                                                            color: pinnedDashboards.includes(child.id)
                                                                                ? '#bf9000'
                                                                                : '#7e94ac',
                                                                            transform: 'rotate(-45deg)',
                                                                            cursor: 'pointer',
                                                                        }"
                                                                        (click)="togglePin(child.id)"
                                                                        title="{{
                                                                            pinnedDashboards.includes(child.id)
                                                                                ? 'Unpin'
                                                                                : 'Pin'
                                                                        }}"></i>
                                                                    <a
                                                                        routerLink="/dashboard/{{ child.id }}"
                                                                        onclick="$('.offcanvas').offcanvas('hide')"
                                                                        ><i
                                                                            class="m-menu__link-icon menu_icon flaticon-graphic-2"></i>
                                                                        {{ child.name }}</a
                                                                    >
                                                                </div>
                                                            }
                                                        </li>
                                                    }
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            }
                            <!-- News -->
                            @if (item.label === 'News') {
                                <div>
                                    @for (element of news; track element; let j = $index) {
                                        @if (element.dashboard) {
                                            <div
                                                class="accordion"
                                                [id]="
                                                    element.dashboard !== null
                                                        ? element.dashboard.split(' ').join('') + '-n'
                                                        : element.dashboard
                                                ">
                                                <div class="accordion-item">
                                                    <h2 class="accordion-header" id="flush-headingOne">
                                                        <button
                                                            class="accordion-button collapsed"
                                                            type="button"
                                                            data-bs-toggle="collapse"
                                                            [attr.data-bs-target]="
                                                                '#' +
                                                                item.name +
                                                                '-' +
                                                                element.dashboard.split(' ').join('')
                                                            "
                                                            aria-expanded="false"
                                                            aria-controls="{{ element.dashboard }}">
                                                            {{ element.dashboard }}
                                                            @for (item of element.children; track item) {
                                                                <span>
                                                                    @if (item.isNew) {
                                                                        <span
                                                                            style="
                                                                                top: -5px;
                                                                                right: -2px;
                                                                                color: #bf9000;
                                                                                font-weight: bold;
                                                                                position: relative;
                                                                                font-size: 8px;
                                                                            "
                                                                            >NEW</span
                                                                        >
                                                                    }
                                                                </span>
                                                            }
                                                        </button>
                                                    </h2>
                                                    <div
                                                        [id]="item.name + '-' + element.dashboard.split(' ').join('')"
                                                        class="accordion-collapse collapse"
                                                        aria-labelledby="{{ element.dashboard }}"
                                                        [attr.data-bs-parent]="
                                                            '#' + element.dashboard.split(' ').join('') + '-n'
                                                        ">
                                                        <div class="accordion-body">
                                                            <ul class="m-menu__subnav" class="news-list">
                                                                @for (
                                                                    child of element.children;
                                                                    track child;
                                                                    let i = $index
                                                                ) {
                                                                    <li>
                                                                        <ng-container>
                                                                            <div
                                                                                class="icon-container news-clickable"
                                                                                data-bs-toggle="modal"
                                                                                [attr.data-bs-target]="
                                                                                    '#modal' + j + '-' + i
                                                                                ">
                                                                                <div
                                                                                    class="news-icon"
                                                                                    [style.background]="child.color">
                                                                                    <mat-icon
                                                                                        style="
                                                                                            color: white;
                                                                                            font-size: 16px;
                                                                                        "
                                                                                        >{{ child.icon }}</mat-icon
                                                                                    >
                                                                                </div>
                                                                                <div class="icontitle-container">
                                                                                    <span class="m-subheader__title">{{
                                                                                        child.title
                                                                                    }}</span>
                                                                                </div>
                                                                            </div>
                                                                        </ng-container>
                                                                    </li>
                                                                }
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        }
                                    }
                                </div>
                            }
                            <!-- Settings -->
                            @if (item.has_presentation && item.label !== 'News' && company === 'lhg') {
                                <div class="accordion" id="{{ item.name }}-ps">
                                    <div class="accordion-item">
                                        <h2 class="accordion-header" id="flush-headingOne">
                                            <button
                                                class="accordion-button collapsed"
                                                type="button"
                                                data-bs-toggle="collapse"
                                                [attr.data-bs-target]="'#' + item.name + '-pas'"
                                                aria-expanded="false"
                                                aria-controls="{{ item.name }}">
                                                Settings
                                            </button>
                                        </h2>
                                        <div
                                            [id]="item.name + '-pas'"
                                            class="accordion-collapse collapse"
                                            aria-labelledby="{{ item.name }}"
                                            [attr.data-bs-parent]="'#' + item.name + '-ps'">
                                            <div class="accordion-body">
                                                <ul class="m-menu__subnav">
                                                    @for (child of item.children; track child) {
                                                        <li>
                                                            @if (child.type == 'Settings') {
                                                                <i
                                                                    class="fa fa-thumb-tack"
                                                                    [ngStyle]="{
                                                                        color: pinnedDashboards.includes(child.id)
                                                                            ? '#bf9000'
                                                                            : '#7e94ac',
                                                                        transform: 'rotate(-45deg)',
                                                                        cursor: 'pointer',
                                                                    }"
                                                                    (click)="togglePin(child.id)"
                                                                    title="{{
                                                                        pinnedDashboards.includes(child.id)
                                                                            ? 'Unpin'
                                                                            : 'Pin'
                                                                    }}"></i>
                                                                <a
                                                                    routerLink="/dashboard/{{ child.id }}"
                                                                    onclick="$('.offcanvas').offcanvas('hide')"
                                                                    ><i
                                                                        class="m-menu__link-icon menu_icon flaticon-line-graph"></i>
                                                                    {{ child.name }}</a
                                                                >
                                                            }
                                                        </li>
                                                    }
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            }
                            <!-- Presentation -->
                            @if (item.has_presentation && item.label !== 'News' && item.label !== 'Settings') {
                                <div class="accordion" id="{{ item.name }}-ps">
                                    <div class="accordion-item">
                                        <h2 class="accordion-header" id="flush-headingOne">
                                            <button
                                                class="accordion-button collapsed"
                                                type="button"
                                                data-bs-toggle="collapse"
                                                [attr.data-bs-target]="'#' + item.name + '-pas'"
                                                aria-expanded="false"
                                                aria-controls="{{ item.name }}">
                                                Presentations
                                            </button>
                                        </h2>
                                        <div
                                            [id]="item.name + '-pas'"
                                            class="accordion-collapse collapse"
                                            aria-labelledby="{{ item.name }}"
                                            [attr.data-bs-parent]="'#' + item.name + '-ps'">
                                            <div class="accordion-body">
                                                <ul class="m-menu__subnav">
                                                    @for (child of item.children; track child) {
                                                        <li>
                                                            @if (child.type == 'Custom Presentations') {
                                                                <i
                                                                    class="fa fa-thumb-tack"
                                                                    [ngStyle]="{
                                                                        color: pinnedDashboards.includes(child.id)
                                                                            ? '#bf9000'
                                                                            : '#7e94ac',
                                                                        transform: 'rotate(-45deg)',
                                                                        cursor: 'pointer',
                                                                    }"
                                                                    (click)="togglePin(child.id)"
                                                                    title="{{
                                                                        pinnedDashboards.includes(child.id)
                                                                            ? 'Unpin'
                                                                            : 'Pin'
                                                                    }}"></i>
                                                                <a
                                                                    routerLink="/dashboard/{{ child.id }}"
                                                                    onclick="$('.offcanvas').offcanvas('hide')"
                                                                    ><i
                                                                        class="m-menu__link-icon menu_icon flaticon-line-graph"></i>
                                                                    {{ child.name }}</a
                                                                >
                                                            }
                                                        </li>
                                                    }
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            }
                            @if (item.has_commercial_plan && item.label !== 'News' && item.label !== 'Settings') {
                                <div class="accordion" id="{{ item.name }}-cp-root">
                                    <div class="accordion-item">
                                        <h2 class="accordion-header" id="flush-headingOne">
                                            <button
                                                class="accordion-button collapsed"
                                                type="button"
                                                data-bs-toggle="collapse"
                                                [attr.data-bs-target]="'#' + item.name + '-cpas'"
                                                aria-expanded="false"
                                                aria-controls="{{ item.name }}">
                                                Commercial Plan
                                            </button>
                                        </h2>
                                        <div
                                            [id]="item.name + '-cpas'"
                                            class="accordion-collapse collapse"
                                            aria-labelledby="{{ item.name }}"
                                            [attr.data-bs-parent]="'#' + item.name + '-ps'">
                                            <div class="accordion-body">
                                                <ul class="m-menu__subnav">
                                                    @for (child of item.children; track child) {
                                                        <li>
                                                            @if (child.type == 'Commercial Plan') {
                                                                <i
                                                                    class="fa fa-thumb-tack"
                                                                    [ngStyle]="{
                                                                        color: pinnedDashboards.includes(child.id)
                                                                            ? '#bf9000'
                                                                            : '#7e94ac',
                                                                        transform: 'rotate(-45deg)',
                                                                        cursor: 'pointer',
                                                                    }"
                                                                    (click)="togglePin(child.id)"
                                                                    title="{{
                                                                        pinnedDashboards.includes(child.id)
                                                                            ? 'Unpin'
                                                                            : 'Pin'
                                                                    }}"></i>
                                                                <a
                                                                    routerLink="/dashboard/{{ child.id }}"
                                                                    onclick="$('.offcanvas').offcanvas('hide')"
                                                                    ><i
                                                                        class="m-menu__link-icon menu_icon flaticon-line-graph"></i>
                                                                    {{ child.name }}</a
                                                                >
                                                            }
                                                        </li>
                                                    }
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                </div>
            }
        </div>
    </div>
</div>
<!-- end::Header -->

<!-- ModalNewsNav -->
@for (element of news; track element; let j = $index) {
    <div>
        @for (item of element.children; track item; let i = $index) {
            <div
                class="modal"
                [id]="'modal' + j + '-' + i"
                tabindex="-1"
                [attr.aria-labelledby]="'modal' + j + '-' + i"
                aria-hidden="true">
                <div class="modal-dialog">
                    <div class="modal-content">
                        <div class="modal-header">
                            <div class="title-container-popup">
                                <div class="icon-container-popup">
                                    <div class="news-icon-popup" [style.background]="item.color">
                                        <mat-icon class="icon-popup" style="color: white; font-size: 16px">{{
                                            item.icon
                                        }}</mat-icon>
                                    </div>
                                </div>
                                <div class="icontitle-container-popup">
                                    <span class="m-subheader__title-popup">PULSE {{ item.author }}</span>
                                </div>
                            </div>
                            <div class="news-modal-title">
                                <h1 class="modal-title fs-5" [id]="'modalTitle' + j + '-' + i">
                                    {{ item.title }} - {{ item.news_date }}
                                </h1>
                            </div>
                        </div>
                        <div class="modal-body-container" style="max-width: 700px">
                            <div
                                class="modal-body"
                                [innerHTML]="item.description"
                                style="object-fit: contain; margin: 0 auto; text-align: center"></div>
                            @if (item.screenshot) {
                                <div
                                    class="modal-picture"
                                    style="margin: 0 auto; margin-bottom: 10px; text-align: center">
                                    <img
                                        [src]="'/screenshots/' + item.screenshot"
                                        style="border-radius: 10px; object-fit: contain; max-width: 100%" />
                                </div>
                            }
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-primary" data-bs-dismiss="modal" aria-label="Close">
                                Close
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        }
    </div>
}
